<template>
  <div v-role="'adm'">

    <v-sheet class="pa-5">

      <v-btn @click="resetar" text icon color="green">
        <v-icon>cached</v-icon>
      </v-btn>

      <v-list>
        <v-list-item v-for="item in abertInsts" :key="item.descricao">

          <v-list-item-content>
            <v-col cols="12" sm="12" md="12">
              <v-switch v-model="item.status_2" @change="showOpcoesAbertura(item)" :label="item.descricao"></v-switch>
              <span style="color:gray; font-size:12px;margin-left:20px"> {{ item.autor }} </span> <br> <br> <span
                style="color:gray; font-size:12px;margin-left:20px"> {{ item.data_2 }} </span>
            </v-col>

          </v-list-item-content>

        </v-list-item>

         <!-- *************************OPÇÕES DE ABERTURA************************************************ -->


                              <v-dialog
                    v-model="dialogOpcoes"
                    persistent
                    max-width="490"
               >
                     
                    <v-card>
                    <v-card-title class="text-h5">
                         Opções de Configuração Abertura/Fecho
                    </v-card-title>
                    <v-card-text>
                         <label>Selecione a opção </label>
                         <v-row>
                            <v-col md="12">
                               <v-combobox
                                  v-model="opcaoConfiguracao"
                                  :items="[{id:1,descricao:'Habilitar apenas para esta instituição'},{id:2,descricao:'Habilitar para Todas'},]"
                                  label="Selecione"
                                  item-text="descricao"
                                  item-value="id"
                                  return-object
                               >

                               </v-combobox>
                            </v-col>
                         </v-row>
                    </v-card-text>
                    <v-card-actions>
                         <v-spacer></v-spacer>
                         <v-btn
                         color="red darken-1"
                         text
                         @click="cancelar()"
                         >
                         Cancelar
                         </v-btn>
                         <v-btn
                         color="green darken-1"
                         text
                         :disabled="!opcaoConfiguracao"
                         @click="habilitarConfiguracao()"
                         >
                         Guardar
                         </v-btn>
                    </v-card-actions>
                    </v-card>
               </v-dialog>




          <!-- ***************************************************************************** -->



        <!--===== CONTAINER PARA ACTUALIZAÇÃO DA LICENÇA ========-->
        <v-list-item>
          <v-list-item-content>
            <v-col cols="12" sm="12" md="12">
              <v-switch disabled v-model="isActive" @change="changeLicenca()" label="Licença"></v-switch>
              <v-col cols="4" sm="4" md="4">
                <div class="combo_box_container">
                  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date" rounded
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="date" label="Data de expiração da licença" readonly v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="salvarData()"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-col>
          </v-list-item-content>
        </v-list-item>
        <!--===== FIM CONTAINER PARA ACTUALIZAÇÃO DA LICENÇA =======-->
      </v-list>
    </v-sheet>

  </div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    abertInsts: [],
    descricao: '',
    status_2: false,

    editedItem: {
      idaberturafechoinstituicao: 0,
      descricao: '',
      status_2: false

    },
    licenca: '',
    isActive: true,
    date: null,
    menu: false,
    opcaoConfiguracao:null,
    dialogOpcoes: false,
    objInstituicao:null

  }),
  created() {
    this.initialize()
    this.carregarLicenca()
    // check if classe has been selected otherwise send back to painel to select
  },

  computed: {
    dataActualLicenca () {
      return ls.get('dataActual')
    }
  },

  methods: {

    // Informação que será exibida caso a licença sege desabilitada
    changeLicenca() {
      Swal.fire('Informação', 'Não se deve desabilitar a licença, apenas alterar a data!', 'info')
      this.isActive = true;
    },


    cancelar(){
      this.initialize()
      this.dialogOpcoes = false
    },

     // Guardar a nova data da licença e recarregando a página
     async salvarData() {
      this.$refs.menu.save(this.date)
      let atualizacao = await axios.post('/actualizarDataLicence', { data: this.date }).then((res) => res);
      if (atualizacao.status == 200 && atualizacao.data.affectedRows >= 1) {

        if(this.date > this.dataActualLicenca) {
            ls.set('licencaExpirada', 0)
          } else {
            ls.set('licencaExpirada', 1)
          }
          ls.set('dataActual', this.date)
        Swal.fire('Sucesso!', 'Licença Actualizada com sucesso.', 'success')
        this.initialize()
        this.carregarLicenca()
      } else {
        Swal.fire('Erro!', 'Ocoreu um erro durante a actualização da licença!', 'error')
      }
    },

    resetar() {
      Swal.fire({
  title: "Informação",
  text: "Tem certeza que quer redefinir as configuracoes de Abertura e fecho ?",
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: "#3085d6",
  cancelButtonColor: "#d33",
  confirmButtonText: "Concordar"
}).then((result) => {
  if (result.isConfirmed) {
    this.aberfechotInstituicaoReset()
    Swal.fire({ title: "Informação!", text: "Configurações redifinidas com sucesso.", icon: "success" });
  }
});

      // confirm('Tem certez que quer redefinir as configuracoes de Abertura e fecho ?') &&
      //   this.aberfechotInstituicaoReset()
    },


    showOpcoesAbertura(item){
       this.opcaoConfiguracao = null
       this.objInstituicao = item
       this.dialogOpcoes =  true
    },

    async habilitarConfiguracao() {

      this.editedItem = this.objInstituicao
      const ls = require('local-storage')
      var params = {
        id: this.objInstituicao.idaberturafechoinstituicao,
        status: !this.objInstituicao.status_2,
        autor: ls.get('nomeUsuario'),
        opcaoAbertura: this.opcaoConfiguracao,
        abertura:this.objInstituicao,
      }

      try {
        let msg = await axios
          .post('/aberfechotInstituicaoUpdate', params)
          .then(res => res.data)
        // this.text = msg[1].insertId
        this.CarregActividades()
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })
        try {
          if (msg.affectedRows >= 1) {
             this.dialogOpcoes = false
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
        } catch (error) { }
      } catch (error) {
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
        this.initialize()
      }
    },

    async CarregActividades() {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },

    async initialize() {
      try {
        this.abertInsts = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async carregarLicenca() {
      try {
        this.licenca = await axios.get('/licencaInstituicaoLogada').then((res) => res.data[0].dataExpiracao);
        this.date = new Date(this.licenca).toISOString().substr(0, 10)
      } catch (error) {
        console.log(error);
        Swal.fire('Erro!', 'Ocorreu um erro durante durante o carregamento da licença!', 'error')
      }
    },

    //

    async aberfechotInstituicaoReset() {
      try {
        let msg = await axios
          .post('/aberfechotInstituicaoReset')
          .then(res => res.data)
        // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })
        this.initialize()
      } catch (error) {

      }
    }

  }

}

</script>
